<template>
  <div>
    <form @submit.prevent="submit">
      <fields />
      <div>
        <b-button type="submit" variant="primary">
          {{ $t('general.save') }}
        </b-button>
        <b-button type="button" variant="light" class="ml-2" @click="cancel">
          {{ $t('general.cancel') }}
        </b-button>

        <b-button
          v-b-modal="`airport-companies`"
          type="button"
          class="ml-2 float-right"
        >
          {{ $t('airports.auto_assign') }}
        </b-button>
      </div>
    </form>
    <template v-if="id">
      <companies :airport-id="id" />
    </template>
  </div>
</template>

<script>
import { ResourceFormMixin } from 'stylemix-vue-admin'
import AirportsApi from './Api'
import Companies from './companies/Companies'

export default {
  name: 'AirportForm',
  components: { Companies },
  mixins: [ResourceFormMixin],

  data() {
    return {
      base: 'airports',
      formLoaded: false,
    }
  },

  watch: {
    currentDivision: {
      handler(newVal) {
        if (newVal && !this.formLoaded) {
          this.formLoaded = true
          this.loadForm()
        }
      },
      immediate: true,
    },
  },

  methods: {
    api() {
      return new AirportsApi().setParameters({
        division_id: this.currentDivision?.id,
      })
    },

    submit() {
      this.save().then(() => {
        this.$toast.success('Airport was saved successfully')
      })
    },
  },
}
</script>
